import { useQuery } from '@tanstack/react-query';
import type { UseQueryOptions } from '@tanstack/react-query';

import { useApi } from 'services/api';

const useTenantProfiles = (
  tenantId: string,
  profileType: 'intel' | 'script',
  config?: Omit<UseQueryOptions<unknown, unknown, unknown, string[]>, 'queryKey' | 'queryFn'>,
) => {
  const api = useApi();

  return useQuery({
    queryKey: ['tenants', tenantId, 'smf', 'profiles', profileType] as string[],
    queryFn: () =>
      api.get(`/tenants/${tenantId}/smf/profiles`, {
        params: {
          QueryConstraint: JSON.stringify({ profileType }),
        },
      }),
    ...config,
  });
};

export default useTenantProfiles;
